<script>
  import { VIDEOS } from "../consts";
  import { activeVideo, dwellVideo, experience, introSeen } from "@stores/global";
  import Video from "@components/Video";

  export let src;

  $: active = $activeVideo === VIDEOS.DWELL;
  $: transparent = $experience.poster && !$introSeen;
</script>

<!--
  Adding the timestamp to the src means the dwell has an automatic poster,
  which is useful in iOS low power mode
-->
<Video bind:element={$dwellVideo} muted={true} {active} src={`${src}#t=0.5`} {transparent} type={VIDEOS.DWELL} />
